import { Component, AfterViewInit, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild, SimpleChanges } from '@angular/core';

import { ApiError, BaseFilterCollapse, BaseFilterCollapseService, MessageService } from '../../../core';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { ClienteGrupoEconomicoFilter } from './cliente-grupo-economico-filter';
import { clienteGrupoEconomicoSituacoes } from '../cliente-grupo-economico-situacao';

@Component({
    selector: 'sgt-cliente-grupo-economico-filter-collapse',
    templateUrl: './cliente-grupo-economico-filter-collapse.component.html',
    styleUrls: ['./cliente-grupo-economico-filter-collapse.component.less']
})
export class ClienteGrupoEconomicoFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = false;

    @Input() filter: ClienteGrupoEconomicoFilter;
    @Output() filterInitialized = new EventEmitter<any>();
    situacoes = clienteGrupoEconomicoSituacoes;

    // Representantes
    isFirstChangeRepresentante = true;

    constructor(private baseFilterCollapseService: BaseFilterCollapseService,
                private messageService: MessageService) { }

    ngOnInit() {
        // Iniciando filtro
        this.initFilter();
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
          jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    /** Inicializa o filtro */
    private initFilter() {
        // Emitindo o evento de que o filtro foi inicializado
        this.filterInitialized.emit();
    }


    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);
    }

    /** Ao alterar os representantes */
    onChangeRepresentantes() {
        if (this.isFirstChangeRepresentante) {
            this.isFirstChangeRepresentante = false;
            return;
        }

        this.isFilterDirty = true;
    }
}
